import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface AlertContainerProps {
	message: string | ReactNode;
}

const AlertContainer = ({ message }: AlertContainerProps) => {
	return (
		<div className="flex w-full flex-col items-center gap-3 px-2 py-2 text-center">
			<div className="flex justify-center text-rose-500">
				<div className="rounded-full bg-rose-50 p-3">
					<AlertTriangle size={24} />
				</div>
			</div>
			<div className="space-y-1">
				<h3 className="text-sm font-black uppercase tracking-wide text-rose-600">
					Atenção
				</h3>
				<div className="text-sm leading-relaxed text-stone-600">
					{message}
				</div>
			</div>
		</div>
	);
};

export { AlertContainer };
